import styled from 'styled-components';
import { Select as AntSelect } from '@vertem-core/vertice-ds';

export const paddingResponsive = '40px';

export interface StyledLabelProps {
  isFocused: boolean;
  hasValue: boolean;
}

export const SelectWrapper = styled.div`
  position: relative;
`;

export const StyledLabel = styled.label<StyledLabelProps>`
  position: absolute;
  top: ${(props) => (props.isFocused || props.hasValue ? '8px' : 'calc(50%)')};
  left: ${paddingResponsive};
  transform: translateY(${(props) => (props.isFocused || props.hasValue ? '0' : '-50%')});
  font-size: ${(props) => (props.isFocused || props.hasValue ? '12px' : '16px')};
  color: ${(props) => (props.isFocused ? 'var(--colorTextInput)' : 'var(--colorTextPlaceholder)')};
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 999;
`;

export const StyledSelect = styled(AntSelect)`
  text-align: left;

  &.ant-select-single.ant-select-lg {
    height: 50px !important;
  }
  &.ant-select-selector {
    height: 50px !important;
    padding: 20px ${paddingResponsive} 8px ${paddingResponsive} !important;
    display: flex;
    align-items: center;
  }
  .ant-select-selector {
    height: 50px !important;
    padding: 20px ${paddingResponsive} 8px ${paddingResponsive} !important;
    display: flex;
    align-items: center;
  }
`;

